import ipRegex from "ip-regex";
import isCidr from "is-cidr";

export type Acl = {
  id?: string;
  orgId: string;
  allowedIpAddresses: Array<AddressSetting>;
};

export type AddressSetting = {
  ipAddress: string;
  subnetMask?: number; // This field is filled only in fetched data from backend server.
  remarks: string;
};

export const displayIpAddress = (addressSetting: AddressSetting): string => {
  return addressSetting.subnetMask
    ? `${addressSetting.ipAddress}/${addressSetting.subnetMask}`
    : `${addressSetting.ipAddress}`;
};

const ipv4exact = ipRegex.v4({ exact: true });

// Returns true if the given string is a valid IP address or CIDR notation.
// Only IPv4 is allowed, and IPv6 is not supported.
export const validateIpAddress = (ipAddress: string) => {
  if (isCidr.v4(ipAddress)) {
    return true;
  }

  return ipv4exact.test(ipAddress);
};
